module.exports = __webpack_public_path__ + "img/chystam-party-cepice-background.3065a77.svg";